import { render } from "./TotalUser.vue?vue&type=template&id=24e4dbec&ts=true"
import script from "./TotalUser.vue?vue&type=script&lang=ts"
export * from "./TotalUser.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__